export const sidebarElements = {
  dashboard: {
    displayName: 'Tempo reale',
    iconName: 'dashboard',
    route: '/dashboard',
  },
  history: {
    displayName: 'Storico',
    iconName: 'history',
    route: 'history',
  },
  forecast: {
    displayName: 'Previsionale',
    iconName: 'crystal-ball',
    route: 'forecast',
  },
  // stats: {
  //   displayName: 'Statistiche',
  //   iconName: 'chart-dots',
  //   route: '',
  // },
  incentive: {
    displayName: 'Incentivi',
    iconName: 'coin-euro',
    route: '/incentive',
    children: [
      {
        displayName: 'Riepilogo',
        iconName: 'dashboard',
        route: '/incentive/dashboard',
      },
      {
        displayName: 'Pagamenti GSE',
        iconName: 'coins',
        route: '/incentive/payments',
      },
      {
        displayName: 'Ripartizione',
        iconName: 'discount-2',
        route: '/incentive/distribution',
      },
      {
        displayName: 'Calcolo',
        iconName: 'receipt-2',
        route: '/incentive/calculate',
      },
    ],
  },
  cer: {
    displayName: 'Gestione CER',
    iconName: 'packages',
    route: '/cer',
    children: [
      // {
      //   displayName: 'Aggoiungi membro',
      //   iconName: 'user',
      //   route: '/members/add',
      // },
      {
        displayName: 'Lista CER',
        iconName: 'users-group',
        route: '/cer/list',
      },
    ],
  },
  meterReadings: {
    displayName: 'Letture contatori',
    iconName: 'eyeglass-2',
    route: '/meter-readings',
  },
  settings: {
    displayName: 'La tua CER',
    iconName: 'settings',
    route: '/sites',
    children: [
      {
        displayName: 'Aggoiungi sito',
        iconName: 'user',
        route: '/sites/add',
      },
      {
        displayName: 'Lista siti',
        iconName: 'users-group',
        route: '/sites/list',
      },
    ],
  },
  admin: {
    displayName: 'Amministrazione',
    iconName: 'adjustments',
    route: '/administration',
    children: [
      {
        displayName: 'Gestione utenti',
        iconName: 'users-group',
        route: '/administration/users',
      },
      {
        displayName: 'Gestione siti',
        iconName: 'users-group',
        route: '/administration/sites',
      },
      {
        displayName: 'Gestione CER',
        iconName: 'users-group',
        route: '/administration/cer',
      },
    ],
  },

  // {
  //   displayName: 'Intrapresa',
  //   iconName: 'star',
  //   route: 'https://www.intrapresa-it.it/',
  //   external: true,
  // },
};
